'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialLastFmCircular = function TiSocialLastFmCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 35c-4.1 0-7.7-1.5-10.6-4.4-2.9-2.9-4.4-6.5-4.4-10.6 0-4.1 1.5-7.7 4.4-10.6 2.9-2.9 6.5-4.4 10.6-4.4 4.1 0 7.7 1.5 10.6 4.4 2.9 2.9 4.4 6.4 4.4 10.6 0 4.1-1.5 7.7-4.4 10.6-2.9 2.9-6.5 4.4-10.6 4.4z m0-26.7c-3.3 0-6 1.1-8.3 3.4-2.3 2.3-3.4 5-3.4 8.3 0 3.2 1.1 5.9 3.4 8.2 2.3 2.3 5 3.5 8.3 3.5 3.2 0 5.9-1.2 8.2-3.5 2.3-2.3 3.5-5 3.5-8.2 0-3.3-1.2-6-3.5-8.3-2.3-2.3-5-3.4-8.2-3.4z m3.7 15.6c2.2 0 3.3-0.8 3.3-2.2 0-1.3-0.7-2-2.1-2.4l-1.1-0.2c-0.6-0.1-0.9-0.4-0.9-0.9 0-0.6 0.4-0.9 1.2-0.9 0.8 0 1.2 0.3 1.2 1l1.6-0.2c-0.1-1.4-1-2-2.7-2-1.9 0-2.9 0.7-2.9 2.3 0 1.1 0.6 1.8 1.9 2.1l1.1 0.2c0.7 0.2 1.1 0.5 1.1 1 0 0.6-0.6 0.9-1.7 0.9-1.4 0-2.4-0.7-2.8-2l-0.6-1.7c-0.3-1-0.7-1.8-1.2-2.2-0.5-0.4-1.3-0.6-2.4-0.6-1 0-1.9 0.3-2.6 1.1-0.8 0.7-1.2 1.7-1.2 2.9 0 1.2 0.4 2.1 1.1 2.8 0.7 0.7 1.6 1 2.6 1 1 0 1.8-0.2 2.4-0.7l-0.5-1.4c-0.5 0.5-1.1 0.8-1.8 0.8-0.6 0-1.1-0.3-1.6-0.7-0.4-0.5-0.6-1.1-0.6-1.8 0-1 0.2-1.6 0.7-2.1s1-0.6 1.6-0.6c0.6 0 1.1 0.2 1.3 0.5 0.3 0.3 0.6 0.8 0.8 1.5l0.5 1.7c0.6 1.8 2 2.8 4.3 2.8z' })
        )
    );
};

exports.default = TiSocialLastFmCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-last-fm-circular.js
// module id = 3722
// module chunks = 0